import { GeneralListEntry, ListEntryApiResponseObj, PanListEntry, RangeListEntry } from '@brighterion/types/listEntry';
import { LIST_TYPES, MERCHANT_OPTIONS } from 'Common/enums';
import { parseDateInTimeZone, timeZone } from '@brighterion/utils/date-timezone';
import { LIST_ENTRY_DATE_FORMAT } from './constants';

type GetAddListEntryFormInitialValues = {
    listType: SingleListType;
    merchantSpecific: boolean;
};

type GetEditListEntryFormInitialValues = {
    listType: SingleListType;
    currentListEntry: ListEntryApiResponseObj;
};

export const getAddListEntryFormInitialValues = ({ listType, merchantSpecific }: GetAddListEntryFormInitialValues) => {
    const commonProperties = {
        merchantId: '',
        // only used in FE
        merchantOption: merchantSpecific ? [MERCHANT_OPTIONS.SINGLE_MERCHANT] : [MERCHANT_OPTIONS.ALL_MERCHANTS],
        comment: '',
        startTime: '',
        endTime: ''
    };

    switch (listType) {
        // default & custom validation schema: value, comment, merchantId, startTime, endTime
        case LIST_TYPES.GENERAL:
            return {
                value: '',
                ...commonProperties
            } as GeneralListEntry;

        // default & custom validation schemas: merchantId, isValid, comment, startTime, endTime
        case LIST_TYPES.PAN:
            return {
                isValid: false, // exist only in FE to validate PAN value in iframe
                ...commonProperties
            } as PanListEntry;

        // default & custom validation schema: merchantId, from, to, comment, startTime, endtime
        case LIST_TYPES.RANGE:
            return {
                from: '',
                to: '',
                ...commonProperties
            } as RangeListEntry;
        default:
            return {};
    }
};

/**
 * For edit workflow, only startDate, endDate and comment are editable
 *
 */
export const getEditListEntryFormInitialValues = ({
    listType,
    currentListEntry
}: GetEditListEntryFormInitialValues) => {
    const { startTime, endTime, value, comment, merchantId } = currentListEntry;
    const commonProperties = {
        merchantId: merchantId ?? '',
        merchantOption: merchantId ? [MERCHANT_OPTIONS.SINGLE_MERCHANT] : [MERCHANT_OPTIONS.ALL_MERCHANTS],
        comment,
        value,
        startTime: startTime ? parseDateInTimeZone(new Date(startTime), timeZone, LIST_ENTRY_DATE_FORMAT) : '',
        endTime: endTime ? parseDateInTimeZone(new Date(endTime), timeZone, LIST_ENTRY_DATE_FORMAT) : ''
    };

    switch (listType) {
        // default & custom validation schema: value, comment, merchantId, startTime, endTime
        // merchantOption is used in FE only
        case LIST_TYPES.GENERAL:
            return {
                ...commonProperties
            } as GeneralListEntry;

        // default & custom validation schemas: merchantId, isValid, comment, startTime, endTime
        // merchantOption is used in FE only
        case LIST_TYPES.PAN:
            return {
                ...commonProperties
            } as PanListEntry;

        // default & custom validation schema: merchantId, from, to, comment, startTime, endtime
        // merchantOption is used in FE only
        case LIST_TYPES.RANGE:
            return {
                from: '',
                to: '',
                ...commonProperties
            } as RangeListEntry;

        // merchantOption is used in FE only
        default:
            return {
                ...currentListEntry,
                ...commonProperties
            };
    }
};
